export default __webpack_public_path__ + "static/icon-atm-case-studies-darkblue.png";